export const AUTOGENERATED_CERT_DOC_IDS = {
  capitalHolding: 'autogenerated-capital-holding',
  irpf: 'autogenerated-irpf',
} as const;

export type AutogeneratedCertDocId =
  (typeof AUTOGENERATED_CERT_DOC_IDS)[keyof typeof AUTOGENERATED_CERT_DOC_IDS];
